var _circle, _g, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContractExceed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 41,
    fill: "#DE3D3D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-contract-exceed_svg__filter0_d_1_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 26.7a2.7 2.7 0 012.7-2.7h36.468a2.7 2.7 0 012.7 2.7v23.585a2.7 2.7 0 01-2.7 2.7H20.7a2.7 2.7 0 01-2.7-2.7V26.7z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE3D3D",
    d: "M18 31.514h41.868v5.368H18z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 50.5,
    r: 9.5,
    fill: "#A21919"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.058 46.593l-.075-2.085h2.22l-.075 2.085-.315 5.535h-1.44l-.315-5.535zm1.035 9.525c-.39 0-.715-.135-.975-.405-.26-.28-.39-.625-.39-1.035 0-.41.13-.75.39-1.02.26-.28.585-.42.975-.42s.715.14.975.42c.27.27.405.61.405 1.02 0 .41-.135.755-.405 1.035-.26.27-.585.405-.975.405z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon-contract-exceed_svg__filter0_d_1_73",
    x: 14,
    y: 22,
    width: 49.868,
    height: 36.985,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.783333 0 0 0 0 0.159931 0 0 0 0 0.159931 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_73"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_73",
    result: "shape"
  })))));
}
export default __webpack_public_path__ + "dc0371bbb5d51130b1ad9c7f2ebe7682.svg";
export { SvgIconContractExceed as ReactComponent };